import slick from 'slick-carousel';

(function( $ ) {
  $('.widget-area .wp-block-handpicked-products .wc-block-grid__products').slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $('.cross-sells .products').slick({
    arrows: false,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    speed: 300,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $('.single-product .up-sells .products').slick({
    arrows: false,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    speed: 300,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });

  $('.single-product .related .products').slick({
    arrows: false,
    autoplay: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    speed: 300,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
})(jQuery);


// WEBPACK FOOTER //
// ./resources/js/partials/carousels.js